"use client";

import { Button } from "@mui/material";
import { openCookieSettings } from "@/src/components/common/cookie-manager/consent-storage";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

export default function CookieSettingsLink() {
  return (
    <Button
      type="button"
      onClick={openCookieSettings}
      sx={{
        color: "custom.footerText",
        fontFamily: FONT_UI,
        fontSize: "0.75rem",
        borderRadius: 0,
        textTransform: "none",
        textDecoration: "underline",
        textUnderlineOffset: "0.15em",
        paddingBlock: 0.5,
        paddingInline: 0,
        minWidth: 0,
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: "transparent",
        },
      }}
    >
      Cookie Settings
    </Button>
  );
}
